<div class="progress-container">
  <mat-progress-bar mode="determinate" value="75"></mat-progress-bar>
</div>

<div id="summary">
  <div class="title-container">
    <h1>{{ "summary.title" | translate }}</h1>
  </div>

  <form name="myForm" #myForm>
    <div class="summary-container">
      <ul>
        @if (usersInWaitingList > 0) {
          <li class="warning">
            <img class="icon" src="../../../assets/img/alert.svg" alt="alert" />
            <div class="wrap-info">
              <div class="title">{{ "warning" | translate }}</div>
                @if (usersInWaitingList == 1) {
                  <div class="content">
                    {{ usersInWaitingList }}
                    {{ "summary.message_warning" | translate }}
                  </div>
                } @else {
                  <div class="content">
                    {{ usersInWaitingList }}
                    {{ "summary.message_warning2" | translate }}
                  </div>
                }
            </div>
          </li>
        }

        <li>
          <div class="title">{{ "summary.form_event" | translate }}</div>
          <div class="content">
            {{
              eventObject!.event_name[userLanguage] ||
                eventObject!.event_name[languages.default]
            }}
          </div>
        </li>
        <li>
          <div class="title">{{ "summary.form_date" | translate }}</div>
          <div class="content">{{ event_date }}</div>
        </li>
        <li>
          <div class="title">{{ "summary.form_time" | translate }}</div>
          <div class="content">{{ convertTime(event_time, userLanguage) }}</div>
        </li>
        <!-- <li>
          <div class="title">{{ 'summary.event_location' | translate }}</div>
          <div class="content">{{ event_location }}</div>
        </li> -->

        @if (isMassive) {
          <li>
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>{{
                "summary.form_list_participants" | translate
              }}</mat-label>
              <input
                matInput
                required
                type="number"
                id="numeroPartecipanti"
                name="numeroPartecipanti"
                #numeroPartecipanti="ngModel"
                [ngClass]="!reservationModel.number_of_users ? 'no-value' : ''"
                [(ngModel)]="reservationModel.number_of_users"
                [max]="maxNumberUsers"
                min="1"
              />
              @if (numeroPartecipanti.invalid && (numeroPartecipanti.dirty || numeroPartecipanti.touched)) {
                <mat-error>
                  <div>{{ "summary.form_min_participants" | translate }}</div>
                  <div>
                    {{ "summary.form_max_participants" | translate }}
                    {{ maxNumberUsers }}
                  </div>
                </mat-error>
              }
            </mat-form-field>
          </li>
        } @else {
          <li>
            <div class="title">{{ "summary.form_participants" | translate }}</div>
              @for (el of selected_profiles; track el.uuid_passenger) {
                <div class="content">{{ el.displayName }}</div>
              }
          </li>
        }
      </ul>
    </div>
  </form>

  <div class="btn-container">
    @if (old_reservation) {
      <button
        [disabled]="!myForm.checkValidity()"
        class="my-button"
        (click)="onSubmit()"
      >
        {{ "summary.confirm_change" | translate }}
      </button>
    }@else {
          <button
        [disabled]="!myForm.checkValidity()"
        class="my-button"
        (click)="onSubmit()"
      >
        {{ "summary.confirm_pre" | translate }}
      </button>
    }

  </div>
</div>
